module.exports = __webpack_public_path__ + "img/criptan.4593c89b.png";